var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IElUploadFile',_vm._g(_vm._b({ref:"file",staticStyle:{"display":"none"},attrs:{"fileName":"file","uploadHandler":_vm.uploadHandler,"isAuthUpload":"","fileType":_vm.fileType}},'IElUploadFile',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }